// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__23_QG","title":"BackImages_title__8Zt1p","images":"BackImages_images__RLOEL"};